import config from '../../../share/config';
import util from '../../../share/util/utils';
import { printContent, loadImageAsBase64 } from '../../../share/util/printUtils';
import resource from '../../../share/util/resourceMap';

// システム名引き当て用i18nMap
const FFD_I18N_MAP = require('../../../data/ffdi18nKeyMap.json');
// 結果判定一覧の表の最大項目数
const MAX_LEFT_TABLE_ITEMS = 28;
// 国内車両非表示の帳票グループ（カテゴリ：タイヤ）
const JPN_FILTER_FORM_GROUP = 4;

export default {
  name: 'diagPrintModal',
  data() {
    return {
      printFormatSrc: '',
      resultNgCss: 'result-ng-color', // NG用CSS（赤文字）
      inspectionDate: '', // 日付
      mileage: '', // 走行距離
      resultLeftTableItems: null, // 結果一覧テーブル（左表）
      resultRightTableItems: null, // 結果一覧テーブル（右表）
      resultFormGroupSystems: {
        1: { is_display: false, systems: '', style: { top: '14.0%', left: '8.2%' } },   // エンジン
        2: { is_display: false, systems: '', style: { top: '14.0%', left: '30.3%' } },  // ドライブトレーン
        3: { is_display: false, systems: '', style: { top: '14.0%', left: '52.5%' } },  // 先進安全システム
        4: { is_display: false, systems: '', style: { top: '35.4%', left: '8.2%' } },   // タイヤ
        5: { is_display: false, systems: '', style: { top: '35.4%', left: '30.3%' } },  // ステアリング
        6: { is_display: false, systems: '', style: { top: '35.4%', left: '52.5%' } },  // ブレーキシステム
        7: { is_display: false, systems: '', style: { top: '35.4%', left: '74.5%' } },  // サスペンションシステム
        8: { is_display: false, systems: '', style: { top: '14.0%', left: '74.5%' } },  // ボディ外装
        9: { is_display: false, systems: '', style: { top: '24.6%', left: '72.8%' } },  // ボディ内装
        10: { is_display: false, systems: '', style: { top: '24.6%', left: '7.1%' } }   // エンターテイメント
      }, // 帳票上部の帳票グループ毎のNG判定システム番号リスト
    };
  },

  props: {
    vehicleVinProp: { type: String, default: '', required: false },
    vehicleVinTypeProp: { type: String, default: '', required: false },
    initMileage: { type: String, default: '', required: false },
    userInfoProp: {
      type: Object, default: {
        name: '-',
        region: config.REGION_DOMESTIC,
        language: 'en'
      }, required: false
    },
    allDtcTableProp: { type: Object, default: {}, required: false }
  },

  methods: {
    /** 帳票内容の表示 */
    setup: function () {
      // 全DTCデータリストの取得
      let tbl = this.allDtcTableProp ? this.allDtcTableProp.data : [];

      // 日本向けの車両（国内VIN）の場合、国内車両非表示の帳票グループをデータリストから除外する
      if (this.vehicleVinTypeProp === config.VEHICLEINFO_TYPE_CHASSISNUMBER) {
        tbl = tbl.filter(item => item.form_group !== JPN_FILTER_FORM_GROUP);
      }

      // ステータス：DTC取得非対応 または 通信不能の場合、非表示とするため、データリストから除外する
      tbl = tbl.filter(item => item.dtc_status !== config.DTC_STATUS_DTC_NOT_SUPPORT && item.dtc_status !== config.DTC_STATUS_CANNNOT_CONNECT);

      // システム特殊対応のマッピング
      const systemKeyMap = {
        // 後側方警戒支援システム(RH)・後側方警戒支援システム(LH)
        // ユーザーのリージョンが米国の場合、後側方警戒支援システムのシステムキーを切り替える（RDR_NorthAmerica）
        'RVDR': this.userInfoProp.region === config.REGION_NORTH_AMERICA ? `RDR_${config.REGION_NORTH_AMERICA}` : 'RDR',
        'RVDL': this.userInfoProp.region === config.REGION_NORTH_AMERICA ? `RDR_${config.REGION_NORTH_AMERICA}` : 'RDR',
        'RVDR_25ePF': this.userInfoProp.region === config.REGION_NORTH_AMERICA ? `RDR_${config.REGION_NORTH_AMERICA}` : 'RDR',
        'RVDL_25ePF': this.userInfoProp.region === config.REGION_NORTH_AMERICA ? `RDR_${config.REGION_NORTH_AMERICA}` : 'RDR',
        // 前側方レーダ(RH)・前側方レーダ(LH)
        'FCRR': 'FCR(R)',
        'FCRL': 'FCR(R)',
        // パワーウィンドウ (運転席)(助手席)(後席右)(後席左)・パワーウィンドウ（スイッチ）
        'PWM': 'P/W',
        'PWS': 'P/W',
        // ドアミラー (運転席)(助手席)
        'MIR': 'MED',
        // キーレスアクセス＆プッシュスタート (電源)(照合)
        'SMT': 'SMTP'
      };

      // 全DTCデータに対し、DTCレコード単位で帳票に必要な情報を取得・編集
      tbl = tbl.map((item) => {
        // i18n のシステムキーを取得
        let i18nSystemKey = resource.findFFDi18nKey(FFD_I18N_MAP, item.system);

        // 【システム特殊対応】一部のシステムの組み合わせの場合、同じシステムとして扱う。
        if (systemKeyMap[i18nSystemKey]) {
          i18nSystemKey = systemKeyMap[i18nSystemKey];
        }

        // 判定結果
        let isResultNg = false;
        // DTCが存在し且つ以下の場合、NG判定とする
        // ・【システム特殊対応】エアコン且つ、DTCが"B14A1"以外の場合
        // ・ ステータス：仮故障以外の場合
        // ・ ステータス：確定/仮故障以外の場合
        // ・ ステータス：過去故障以外の場合
        if (item.code !== null 
          && !(i18nSystemKey === 'AC' && item.code === "B14A1")
          && item.dtc_status !== config.DTC_STATUS_TENTATIVE 
          && item.dtc_status !== config.DTC_STATUS_CONFIRM_TENTATIVE 
          && item.dtc_status !== config.DTC_STATUS_PAST) {
          isResultNg = true;
        }

        // 編集結果を返却
        return {
          form_group: item.form_group,                                   // 帳票グループ番号
          form_group_name: this.$t(`printFormat.${item.form_group}`),    // 帳票グループ名（カテゴリ）
          system_id: i18nSystemKey,                                      // システムID
          system_name: this.$t(`printFormat.${i18nSystemKey}`),          // システム名
          is_result_ng: isResultNg,                                      // NG判定（true:NG, false:OK）
        };
      });

      // DTC単位⇒システム単位にリストを編集
      const systemTblItems = [];
      // システムIDでグループ化
      const systemData = util.groupBy(tbl, 'system_id');
      const systemDataItems = Object.keys(systemData)
        .map((k) => { return { key: k, value: systemData[k] }; })
        .sort((a, b) => { return b.key.length - a.key.length; });
      // システム単位のリストへ編集（システム単位で判定情報を集約）
      systemDataItems.forEach((systemDataItem) => {
        const tempItem = {
          form_group: systemDataItem.value[0].form_group,
          form_group_name: systemDataItem.value[0].form_group_name,
          system_id: systemDataItem.key,
          system_name: systemDataItem.value[0].system_name,
          is_system_ng: systemDataItem.value.some(item => item.is_result_ng === true), // 対象システム内のDTCにおいて、一つでもNG（DTCが存在）すれば、対象システムはNGとする
        };
        systemTblItems.push(tempItem);
      });

      // システム単位⇒帳票グループ単位にリストを編集
      const resultTblItems = [];
      let systemNo = 0;
      let leftTableItemsNum = 0;
      // 帳票グループでグループ化
      const data = util.groupBy(systemTblItems, 'form_group');
      const formGroupItems = Object.keys(data)
        .map((k) => { return { key: Number(k), form_group_count: data[k].length, value: data[k] }; })
        .sort((a, b) => { return b.key.length - a.key.length; });
      // 帳票グループ単位にリストを編集
      formGroupItems.forEach((formGroupItem) => {
        // カテゴリボックスの表示対象とする。
        this.resultFormGroupSystems[formGroupItem.key].is_display = true;
        const systemItems = formGroupItem.value;
        // 結果判定一覧の分割数判定
        if (systemNo <= MAX_LEFT_TABLE_ITEMS) {
          // カテゴリのシステム数の合算が最大値を超えない場合、分割数をセット
          leftTableItemsNum = systemNo;
        }
        for (let index = 0; index < systemItems.length; index++) {
          // システム番号の連番設定
          systemNo++;
          // 結果一覧テーブル用のデータ設定
          const tempItem = {
            form_group: systemItems[index].form_group,
            form_group_name: systemItems[index].form_group_name,
            form_group_count: index === 0 ? formGroupItem.form_group_count : 0, // 先頭行にのみカウント数（rowSpan）を設定
            is_form_group_ng: systemItems.some(item => item.is_system_ng === true), // 帳票グループ内のシステムにおいて、一つでもNG（DTCが存在）すれば、帳票グループとしてNGとする
            system_id: systemItems[index].system_id,
            system_no: systemNo,
            system_name: systemItems[index].system_name,
            is_system_ng: systemItems[index].is_system_ng,
          };

          // システムNG判定の場合、帳票上部の帳票グループ毎のシステム番号を設定
          if (tempItem.is_system_ng) {
            // 空でない場合、カンマ付きでシステム番号を追加
            this.resultFormGroupSystems[formGroupItem.key].systems = this.resultFormGroupSystems[formGroupItem.key].systems === '' ?
              String(tempItem.system_no) : this.resultFormGroupSystems[formGroupItem.key].systems + ',' + String(tempItem.system_no);
          }

          // 一覧テーブル用配列に追加
          resultTblItems.push(tempItem);
        }
      });

      // 結果一覧表の左右表への項目の分割
      if (resultTblItems.length > MAX_LEFT_TABLE_ITEMS) {
        // 結果判定一覧（左表）に設定（表の分割数ごとに表示）
        this.resultLeftTableItems = resultTblItems.slice(0, leftTableItemsNum);
        // 結果判定一覧（右表）に設定（表の分割数ごとに表示）
        this.resultRightTableItems = resultTblItems.slice(leftTableItemsNum);
      } else {
        // 結果判定一覧（左表）に全項目を設定
        this.resultLeftTableItems = resultTblItems;
        this.resultRightTableItems = [];
      }
    },

    /**
     * マイレージ設定
     * @param {*} mileage マイレージ入力値
     */
    setMileage: function (mileage) {
      this.mileage = mileage;
    },

    /** 帳票印刷 */
    print: function () {
      // 印刷部分の表示内容を取得
      const element = document.getElementById('printArea');
      // タイトル
      const title = this.$t('message.header_vehicle_dtc_print_modal');
      // 帳票印刷処理
      printContent(element, title, true);
    },
  },

  created() {
    // 帳票印刷画像パスを選択言語によって変更（Base64 に変換された画像を取得）
    loadImageAsBase64(require(`@/assets/img/print/print_format_${this.userInfoProp.language}.png`), (base64Image) => {
      this.printFormatSrc = base64Image; // Base64 データをプロパティに設定
    });

    // 点検日の設定
    this.inspectionDate = util.timeConverter(Date.now(), null, 'day');
    // 走行距離の設定
    this.mileage = this.initMileage;
    // 帳票データの編集
    this.setup();
  },

  mounted() {
    // noop
  },
};